import React from 'react'
import ImagesContainer from 'app/react/components/images/ImagesContainer'
import ImagesContent from 'app/react/components/images/ImagesContent'

export default function ImagesOverview (props) {
  return (
    <ImagesContainer {...props}>
      <ImagesContent/>
    </ImagesContainer>
  )
}